/** Reader's theme choice: "system" follows the device. Signed-in readers keep it on the
 *  account (PATCH /me); the device-local copy covers signed-out reading and pre-auth paint. */

export type ThemeChoice = "system" | "light" | "dark";

const KEY = "learn:theme";
const media = window.matchMedia("(prefers-color-scheme: dark)");
let current: ThemeChoice = "system";

export function themeOf(value: unknown): ThemeChoice {
  return value === "light" || value === "dark" || value === "system" ? value : "system";
}

export function localTheme(): ThemeChoice {
  return themeOf(localStorage.getItem(KEY));
}

export function applyTheme(choice: ThemeChoice): void {
  current = choice;
  localStorage.setItem(KEY, choice);
  document.documentElement.dataset.theme =
    choice === "system" ? (media.matches ? "dark" : "light") : choice;
}

media.addEventListener("change", () => applyTheme(current));
